import React, { useState } from 'react';

/**
 * Production-resilient <img>:
 *   - lazy-loads off-screen (avoids cellular timeouts)
 *   - on load error, swaps to a CSS-only navy/gold gradient placeholder so
 *     a broken remote URL never leaves an empty grey rectangle.
 *   - decoding="async" keeps the main thread responsive.
 */
export default function SafeImage({
  src,
  alt = '',
  className = '',
  width,
  height,
  ...rest
}) {
  const [failed, setFailed] = useState(!src);
  if (failed) {
    return (
      <div
        role="img"
        aria-label={alt}
        className={`${className} relative overflow-hidden`}
        style={{
          background:
            'linear-gradient(135deg, #0B1F3A 0%, #142a4d 55%, #1d3a66 100%)',
        }}
      >
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'url(/brand/shield.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'min(45%, 140px)',
            opacity: 0.85,
          }}
        />
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      width={width}
      height={height}
      className={className}
      onError={() => setFailed(true)}
      {...rest}
    />
  );
}
